import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import { NavLink, useHistory } from "react-router-dom";
import { AppContext } from "../../../../App";
import { service } from "../../../../rbac-consts";
import { HTTP_STATUSES } from "../../../../utils/consts";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import Can from "../../../can/Can";
import GoToBackButton from "../../../elements/goToBack/GoToBack";
import Notification from "../../../elements/notification/Notification";
import PageSpinner from "../../../elements/spinner/PageSpinner";
import { StyledContentWrapper } from "../../../styles/styledMain";
import { StyledCol, StyledTable, StyledTableBody, StyledTableHead, StyledTableRow } from "../../../styles/styledTable";
import { StyledDocumentTitle, StyledDocumentWrapper } from "../../../styles/styledTextDocument";
import { StyledServiceDetailsWrapper } from "../../styledServiceDetails";
import ClientListContainer from "./clientsList/ClientListContainer";
import ServiceNicknameForm from "./ServiceNicknameForm";

const ServiceDetailsContainer = ({ match }) => {
  const { user } = useContext(AppContext);

  const { t } = useTranslation("servicePage");
  const [serviceDetails, setServiceDetails] = useState(null);

  const history = useHistory();

  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  useEffect(() => {
    axios.get("/api/services/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setServiceDetails(response.data);
      }
    }).catch(error => {
      setNotification({ ...notification, visible: true, type: "error", message: error.response.data.message });
    });
  }, []);

  if (!serviceDetails) {
    return <PageSpinner
      position="center"
      pt="60"
      pb="60"
    />;
  }

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledContentWrapper>
        <Helmet>
          <title>{serviceDetails.title} • eXsoft.io</title>
        </Helmet>
        <StyledServiceDetailsWrapper>
          <div className="services-details-head">
            <GoToBackButton handler={() => {history.goBack();}} />
          </div>
          <StyledDocumentWrapper>
            <StyledDocumentTitle
              as="h2"
              size="18"
            >
              {serviceDetails.title}
            </StyledDocumentTitle>
            {/*<StyledDocumentText size="14">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda, autem culpa, cum deleniti id modi
              obcaecati officia quis, ratione repellendus repudiandae tempora ullam vitae? Consectetur eius molestiae
              nisi
              quos velit.
            </StyledDocumentText>

            <StyledDocumentText size="14">
              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Assumenda, autem culpa, cum deleniti id modi
              obcaecati officia quis, ratione repellendus repudiandae tempora ullam vitae? Consectetur eius molestiae
              nisi
              quos velit.
            </StyledDocumentText>*/}
            <StyledTable
              size="14"
              className="access-level-table"
            >
              <StyledTableHead
                col="2"
                className="access-level-table__head"
              >
                <StyledCol>{t("details.key")}:</StyledCol>
                <StyledCol>{t("details.value")}:</StyledCol>
              </StyledTableHead>
              <StyledTableBody className="access-level-table__body">
                <StyledTableRow
                  col="2"
                  className="access-level-table__row"
                >
                  <StyledCol data-title={t("details.key")}>
                    ID
                  </StyledCol>
                  <StyledCol data-title={t("details.value")}>
                    {serviceDetails.id}
                  </StyledCol>
                </StyledTableRow>

                <StyledTableRow
                  col="2"
                  className="access-level-table__row"
                >
                  <StyledCol data-title={t("details.key")}>
                    Name
                  </StyledCol>
                  <StyledCol data-title={t("details.value")}>
                    {serviceDetails.name}
                  </StyledCol>
                </StyledTableRow>
                <StyledTableRow
                  col="2"
                  className="access-level-table__row"
                >
                  <StyledCol data-title={t("details.key")}>
                    Nickname
                  </StyledCol>
                  <StyledCol data-title={t("details.value")}>
                    <ServiceNicknameForm
                      service={serviceDetails}
                      t={t}
                      notification={notification}
                      setNotification={setNotification}
                    />
                  </StyledCol>
                </StyledTableRow>
                <StyledTableRow
                  col="2"
                  className="access-level-table__row"
                >
                  <StyledCol data-title={t("details.key")}>
                    Title
                  </StyledCol>
                  <StyledCol data-title={t("details.value")}>
                    {serviceDetails.title}
                  </StyledCol>
                </StyledTableRow>

                <StyledTableRow
                  col="2"
                  className="access-level-table__row"
                >
                  <StyledCol data-title={t("details.key")}>
                    Tag
                  </StyledCol>
                  <StyledCol data-title={t("details.value")}>
                    {serviceDetails.tag}
                  </StyledCol>
                </StyledTableRow>
              </StyledTableBody>
            </StyledTable>
          </StyledDocumentWrapper>
          <Can
            role={user.roles}
            perform={service.CLIENT_LIST}
            yes={() => (
              <>
                <StyledDocumentTitle
                  as="h2"
                  size="18"
                >
                  {t("clients")}
                </StyledDocumentTitle>
                <ClientListContainer
                  t={t}
                  serviceId={match.params.id}
                  notification={notification}
                  setNotification={setNotification}
                />
              </>
            )}
          />
        </StyledServiceDetailsWrapper>
      </StyledContentWrapper>
    </>
  );
};

export default ServiceDetailsContainer;